import { Theme } from "@mui/material";

export const autocompleteStyles = (theme: Theme) => ({
  backgroundColor: theme.palette.white.main,
  "& .MuiAutocomplete-root": {
    padding: 0,
  },
  "&.MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root": {
    padding: 0,
    "& .MuiAutocomplete-endAdornment .MuiIconButton-root": {
      color: theme.palette.dark.main,
    },
  },
  "&.MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root .MuiInputBase-input": {
    paddingTop: "1em",
    paddingBottom: "1em",
  },
  "&.MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root .MuiOutlinedInput-notchedOutline":
    {
      borderColor: theme.palette.dark.main,
    },
  "&.MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline":
    {
      borderColor: theme.palette.dark.main,
      borderWidth: 2,
    },
});

export const inputStyles = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  marginRight: "4.5em",
};
